import request from '@/utils/request';

export const GetCInventoryByPk = parameter => request.post('/cextension/get-c-inventory-by-pk', parameter);

export const GetCInventoryList = parameter => request.post('/cextension/select-c-inventory-by-criterion-bean-vo',  parameter);
export const GetCInventoryTotalList = parameter => request.post('/cextension/select-c-inventorysummary-by-criterion-bean-vo',  parameter);